import React, { ChangeEvent } from 'react';

interface InputAutomacaoNumberProps {
  id: string;
  valorAutomacao: string;
  onValorAutomacaoChange: (valor: string) => void;
}

export const InputAutomacaoNumber: React.FC<InputAutomacaoNumberProps> = ({
  valorAutomacao,
  onValorAutomacaoChange,
  id,
}) => {

  const formatarParaReal = (valor: string) => {
    valor = valor.replace(/\D/g, '');
    valor = (parseInt(valor, 10) / 100).toFixed(2);
    valor = valor.replace('.', ',');
    return valor;
  };

  const handleAutomacaoChange = (event: ChangeEvent<HTMLInputElement>) => {
    let valor = event.target.value;
    valor = formatarParaReal(valor);
    onValorAutomacaoChange(valor);
  };

  return (
    <div>
      <input
        id={id}
        type='text'
        placeholder='Digite um número para automatizar.'
        value={valorAutomacao}
        onChange={handleAutomacaoChange}
      />
    </div>
  );
};
